import i18next from 'i18next';

import {durationToHoursIncludingDays} from './duration-to-hours-including-days';

const hoursAbbr = i18next.t('time.hoursAbbr');
const minutesAbbr = i18next.t('time.minutesAbbr');
export const emptyDuration = `0${hoursAbbr}`;

/**
 * A method that prints a moment duration as a string
 * @param duration The moment duration
 * @param printSign whether the sign (+/-) should be shown
 * @returns a string representation of the duration (e.g. 20h 15m)
 * If you're passing in a duration instance that might have decimal places returned from BE (e.g. by using moment.duration({hours: 8.989999})),
 * please first use decimalHoursToTimeMap
 * @see [renderEmployeeDuration](app/react/profile/leave-widget/helpers.ts)
 * @see [decimalHoursToTimeMap](app/react/staffing-attendance/utils/decimal-time-converter.ts)
 */
export function printDuration(duration: moment.Duration, printSign?: boolean): string {
    if (duration.asMinutes() === 0) {
        return emptyDuration;
    }

    let result: string = '';
    const hours = durationToHoursIncludingDays(duration);
    if (hours === 0) {
        result = `${duration.minutes()}${minutesAbbr}`;
    } else if (duration.minutes() === 0) {
        result = `${hours}${hoursAbbr}`;
    } else {
        result = `${hours}${hoursAbbr} ${Math.abs(duration.minutes())}${minutesAbbr}`;
    }

    return `${printSign && duration.asMinutes() > 0 ? '+' : ''}${result}`;
}
